// The native URL() constructor is far too lenient for validation purposes -
// it percent-encodes spaces and other stray characters into the hostname
// instead of rejecting them, so "not a url at all" parses "successfully".
// This requires an actual domain shape (labels separated by dots, ending in
// an alphabetic TLD), with an optional scheme/port/path - and no whitespace
// anywhere.
const WEB_ADDRESS_PATTERN =
  /^(https?:\/\/)?([A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}(:\d+)?(\/\S*)?$/;

export function isValidWebAddress(value) {
  return WEB_ADDRESS_PATTERN.test(value.trim());
}
